export default __webpack_public_path__ + "static/media/Ellipse 111 (2).6caa6569.png";